/* eslint-disable no-unused-vars */
var resourcesList = ["cache-1nu6f6a.js","code-theme-css-ef37e5d9.js"];
module.exports.list = resourcesList
  